<template>
  <div style="background-color: white; margin-top: 2%; ">
    <button v-if="promptEvent" @click="promptInstall" style="font-size: 110%; padding-left: 1%; padding-right: 1%; color: blue; background-color: white;">
      <div style="font-size:120%">&#x1F449;<u>Installer l'application</u>&#x1F448;</div>
      <div style="color: black;">Il est recommandé d'installer l'application sur votre écran d'accueil pour une expérience optimale.</div>
    </button>
    <div style="font-size:120%" v-if="installed">Ferme cette appli, et retrouve Lynx sur ton écran d'accueil. &#x1F638;</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      promptEvent: null,
      installed: false
    }
  },
  mounted () {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault() // Empêcher le mini-infobar de s'afficher
      this.promptEvent = e // Sauvegarder l'événement pour une utilisation ultérieure
      console.log('Install event ok.')
    })

    window.addEventListener('appinstalled', (evt) => {
      console.log('L\'application a été installée.')
      // Réinitialiser l'état post-installation
      this.installed = true
      this.promptEvent = null
    })
  },
  methods: {
    promptInstall () {
      if (this.promptEvent) {
        this.promptEvent.prompt() // Afficher la boîte de dialogue d'installation
        this.promptEvent.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('Installation acceptée')
            this.installed = true
          } else {
            console.log('Installation refusée')
          }
          this.promptEvent = null // Réinitialiser l'événement après l'interaction
        })
      }
    }
  }
}
</script>
